import React, { Component } from "react"
import glamorous from "glamorous"
import { BrowserRouter } from "react-router-dom"

import Header from "containers/Header"
import Body from "./Body"

import { asyncComponent } from "react-async-component"

const Footer = asyncComponent({
  resolve: () => import("containers/Footer"),
  LoadingComponent: ({ productId }) => <div>Loading {productId}</div>, // Optional
  ErrorComponent: ({ error }) => <div>{error.message}</div>, // Optional
})

const Wrapper = glamorous.div(
  {
    marginTop: 83,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    "@media(max-width: 750px)": {
      marginTop: 143,
    },
  },
  { displayName: "ContentWrapper" }
)

const AppWrapper = glamorous.div(
  {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  { displayName: "AppWrapper" }
)

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <AppWrapper>
          <Header />
          <Wrapper>
            <Body />
            <Footer />
          </Wrapper>
        </AppWrapper>
      </BrowserRouter>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/scenes/App/App.js